import React from "react";
import ErpBridgePanel, { ErpBridgeEvent, ErpBridgeSummary } from "./ErpBridgePanel";

const QA_EVENTS: ErpBridgeEvent[] = [
  {
    eventId: "erpevt_approval_qa001",
    eventType: "APPROVAL",
    paymentId: "qa-payment-1",
    occurredAt: "2026-08-12T01:00:00.000Z",
    vendorCode: "100001",
    vendorName: "QA 식자재상사",
    approvalCode: "QA-APPROVAL-01",
    approvalTransactionId: "26081200000001",
    cardIssuerCode: "CC",
    cardIssuerName: "QA카드",
    signedErpAmount: 500000,
    balanceAfter: 500000,
    erpStatus: "PENDING",
  },
  {
    eventId: "erpevt_cancellation_qa001",
    eventType: "CANCELLATION",
    paymentId: "qa-payment-1",
    occurredAt: "2026-08-12T03:00:00.000Z",
    vendorCode: "100001",
    vendorName: "QA 식자재상사",
    approvalCode: "QA-APPROVAL-01",
    approvalTransactionId: "26081200000001",
    signedErpAmount: -50000,
    balanceAfter: 450000,
    erpStatus: "PENDING",
  },
  {
    eventId: "erpevt_approval_qa002",
    eventType: "APPROVAL",
    paymentId: "qa-payment-2",
    occurredAt: "2026-08-12T04:00:00.000Z",
    vendorCode: "100002",
    vendorName: "QA 유통",
    approvalCode: "QA-APPROVAL-02",
    approvalTransactionId: "26081200000002",
    signedErpAmount: 380000,
    balanceAfter: 380000,
    erpStatus: "PENDING",
  },
  {
    eventId: "erpevt_approval_qa003",
    eventType: "APPROVAL",
    paymentId: "qa-payment-3",
    occurredAt: "2026-08-12T05:00:00.000Z",
    vendorCode: "100003",
    vendorName: "QA 농산",
    approvalCode: "QA-APPROVAL-03",
    approvalTransactionId: "26081200000003",
    signedErpAmount: 450000,
    balanceAfter: 450000,
    erpStatus: "PENDING",
  },
];

const QA_SUMMARY: ErpBridgeSummary = {
  bridgeMode: "DRY_RUN",
  mapping: {
    version: "ERP_DEPOSIT_V3_DRAFT_ENTITY_MAPPING",
    status: "CONFIGURATION_PENDING",
  },
  pending: {
    count: 4,
    amount: 1280000,
    eventIds: QA_EVENTS.map((event) => event.eventId),
    events: QA_EVENTS,
    approvalCount: 3,
    cancellationCount: 1,
    positiveAmount: 1330000,
    negativeAmount: -50000,
    netAmount: 1280000,
    truncated: false,
    batchCreationBlocked: false,
  },
  batches: [
    {
      batchId: "B260812-002",
      status: "VERIFY_REQUIRED",
      createdAt: "2026-08-12T06:20:00.000Z",
      createdBy: "QA 담당",
      sourceCount: 3,
      sourceAmount: 930000,
      exportCount: 3,
      exportAmount: 930000,
      erpImportCount: 0,
      erpImportAmount: 0,
      verifiedCount: 0,
      verifiedAmount: 0,
      fileName: "cnfood_erp_deposit_B260812-002.xls",
      fileHash: "b".repeat(64),
      agentId: "QA-AGENT-01",
      agentHost: "QA-PC",
      importStartedAt: "2026-08-12T06:30:00.000Z",
      importCompletedAt: "",
      verifiedAt: "",
      errorCode: "ERP_RESULT_UNCERTAIN",
      errorMessage: "QA synthetic uncertain result",
      mappingVersion: "ERP_DEPOSIT_V3_DRAFT_ENTITY_MAPPING",
      mappingStatus: "CONFIGURATION_PENDING",
      bridgeMode: "DRY_RUN",
      eventCount: 3,
      approvalCount: 2,
      cancellationCount: 1,
      positiveAmount: 980000,
      negativeAmount: -50000,
      netAmount: 930000,
      activeReceiptId: "",
      receiptStatus: "NOT_ISSUED_DRY_RUN",
      reconciliation: {
        sourceCount: 3,
        sourceAmount: 930000,
        exportCount: 3,
        exportAmount: 930000,
        countMatch: true,
        amountMatch: true,
      },
    },
    {
      batchId: "B260812-001",
      status: "FILE_CREATED",
      createdAt: "2026-08-12T02:00:00.000Z",
      createdBy: "QA 담당",
      sourceCount: 2,
      sourceAmount: 170000,
      exportCount: 2,
      exportAmount: 170000,
      erpImportCount: 0,
      erpImportAmount: 0,
      verifiedCount: 0,
      verifiedAmount: 0,
      fileName: "cnfood_erp_deposit_B260812-001.xls",
      fileHash: "a".repeat(64),
      agentId: "",
      agentHost: "",
      importStartedAt: "",
      importCompletedAt: "",
      verifiedAt: "",
      errorCode: "",
      errorMessage: "",
      mappingVersion: "ERP_DEPOSIT_V3_DRAFT_ENTITY_MAPPING",
      mappingStatus: "CONFIGURATION_PENDING",
      bridgeMode: "DRY_RUN",
      eventCount: 2,
      approvalCount: 2,
      cancellationCount: 0,
      positiveAmount: 170000,
      negativeAmount: 0,
      netAmount: 170000,
      activeReceiptId: "",
      receiptStatus: "NOT_ISSUED_DRY_RUN",
      reconciliation: {
        sourceCount: 2,
        sourceAmount: 170000,
        exportCount: 2,
        exportAmount: 170000,
        countMatch: true,
        amountMatch: true,
      },
    },
  ],
};

export default function ErpBridgeQaHarness() {
  return (
    <main className="min-h-screen bg-slate-100 px-4 py-6 lg:px-8">
      <div className="mx-auto max-w-[1500px]">
        <div className="mb-4 border border-blue-200 bg-blue-50 px-4 py-3 text-xs font-black text-blue-900">
          Synthetic QA only · 외부 API/Firestore/KCP/ERP 연결 없음
        </div>
        <ErpBridgePanel
          summary={QA_SUMMARY}
          onReload={async () => QA_SUMMARY}
          onCreateBatch={async () => {
            throw new Error("QA 화면에서는 파일 생성을 실행하지 않습니다.");
          }}
        />
      </div>
    </main>
  );
}
